import MondayBrief from "./MondayBrief";

export default function SampleBrief() {
  return <MondayBrief isSample />;
}
